import { getMessages } from '../../../../../../store/constants';

export const LINKS_TO_CARDS_TITLE = getMessages().getText( 'board_settings.links_to_cards.header');
export const LINKS_TO_CARDS_BUTTON = getMessages().getText( 'board_settings.links_to_cards.button');
export const LINKS_TO_CARDS_DESC = getMessages().getText( 'board_settings.links_to_cards.description');
export const LINKS_TO_CARDS_INSTRUCTION_URL = getMessages().getText( 'board_settings.links_to_cards.instruction.url');
export const LINKS_TO_CARDS_MORE_INSTRUCTIONS = getMessages().getText( 'board_settings.links_to_cards.more_instructions');
